module.exports = __webpack_public_path__ + "img/项目场景_政府考察.66bc6b32.jpg";